import { Page } from "../../../components/page-base";
import {
  BottomContainer,
  StyledButton,
  TopContainer,
  CustomStepper,
  TagContainer,
  ChipGrid,
  KeywordsContainer,
  SelectedChipsContainer,
  InputContainer,
  SuggestionsContainer,
  PlansContainer,
  SearchContainer,
  FirstStep,
  ProfilesContainer,
  LogoutButton,
  DetailsArea,
  OnboardingHelp,
  TermsContainer,
} from "./styles";
import {
  Step,
  StepLabel,
  MobileStepper,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import SelectableTile from "../components/profile-card";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { CategoryChip } from "../components/category";
import { Chip, IconButton, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import GoogleIcon from "@mui/icons-material/Google";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import isMobile from "is-mobile";
import { useDebounce } from "../../../utils/useDebounce";
import { toast } from "react-toastify";
import {
  INewGeoRankingPayload,
  IPlan,
  IRecommendedBriefingPayload,
  IRecommendedCategoriesPayload,
  IRecommendedKeywordsPayload,
  ISearchedProfile,
  IBusinessInfo,
} from "../types";
import { GeoRankingService } from "../services";
import { LoginService } from "../../login/services";
// import { PlanCardNew } from "../components/plan-card";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import Tooltip from "../../../components/tooltip";
import useUserStore from "../../../store/user";
import { Navigate, useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { BusinessInfoForm } from "../components/business-info-form";
import gpv from "../../../assets/images/logo-georanking.png";
// import { PlanCard } from "../components/plan";
import { PlanCardNew } from "../components/plan-card";
import {
  GEORANKING_ONBOARDING_STEPS,
  buildFallbackBriefing,
  buildFallbackCategories,
  buildFallbackKeywords,
  createEmptyBusinessInfo,
  fallbackPlans,
  getStepSupportText,
  isBusinessInfoComplete,
  isValidationStepComplete,
  LEGAL_DOCUMENT_LINKS,
  shouldShowOAuthLoginFirst,
  VALIDATION_CHECKPOINTS,
  VALIDATION_TRUST_SIGNALS,
} from "./onboarding";

export const GeoRanking = () => {
  const { debounce } = useDebounce();
  const { user, clearUser } = useUserStore();
  const navigate = useNavigate();
  const [searchCategories, setSearchCategories] = useState<string>("");
  const [activeStep, setActiveStep] = useState<number>(0);
  const [searchedProfiles, setSearchedProfiles] = useState<ISearchedProfile[]>(
    [],
  );
  const [selectedProfileId, setSelectedProfileId] = useState<string | null>(
    null,
  );
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [categorySearch, setCategorySearch] = useState<string>("");
  const [categories, setCategories] = useState<string[]>([]);
  const [selectedKeywords, setSelectedKeywords] = useState<string[]>([]);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [keywordInput, setKeywordInput] = useState("");
  const [detailsPlan, setDetailsPlan] = useState("");
  const [plans, setPlans] = useState<IPlan[]>([]);
  const [selectedPlanId, setSelectedPlanId] = useState<number | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isStepLoading, setIsStepLoading] = useState(false);
  const [isSearchingProfiles, setIsSearchingProfiles] = useState(false);
  const [isStartingOAuth, setIsStartingOAuth] = useState(false);
  const [paymentError, setPaymentError] = useState<string | null>(null);
  const [filterText, setFilterText] = useState<string>("");
  const [verificationKind, setVerificationKind] = useState<
    "storefront" | "selfie"
  >("storefront");
  const [verificationFile, setVerificationFile] = useState<File | null>(null);
  const [verificationPreviewUrl, setVerificationPreviewUrl] =
    useState<string>("");
  const [acceptedTerms, setAcceptedTerms] = useState<boolean>(() => {
    return localStorage.getItem("georanking_terms_accepted") === "true";
  });
  const [businessInfo, setBusinessInfo] = useState<IBusinessInfo>(() => {
    // Tenta recuperar do localStorage ao carregar
    const saved = localStorage.getItem("georanking_business_info");

    const defaultInfo = createEmptyBusinessInfo();

    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        // Verifica se os campos novos existem, senão usa o padrão
        if (parsed.razaoSocial !== undefined) {
          return { ...defaultInfo, ...parsed };
        }
        // Se for um formato antigo, limpa e usa o padrão
        localStorage.removeItem("georanking_business_info");
        return defaultInfo;
      } catch {
        return defaultInfo;
      }
    }
    return defaultInfo;
  });

  const handleAcceptedTermsChange = (checked: boolean) => {
    setAcceptedTerms(checked);
    localStorage.setItem("georanking_terms_accepted", String(checked));
  };

  const handleVerificationFileChange = (file?: File | null) => {
    if (!file) {
      return;
    }

    setVerificationFile(file);
    setVerificationPreviewUrl((previousUrl) => {
      if (previousUrl) {
        URL.revokeObjectURL(previousUrl);
      }
      return URL.createObjectURL(file);
    });
  };

  const handleGoogleOAuth = async () => {
    setIsStartingOAuth(true);
    try {
      await LoginService.startGoogleOAuth();
    } finally {
      setIsStartingOAuth(false);
    }
  };

  const handleBusinessInfoChange = (
    field: string,
    value:
      | string
      | IBusinessInfo["enderecoComercial"]
      | IBusinessInfo["legalRepresentative"]
      | IBusinessInfo["accountManager"],
  ) => {
    setBusinessInfo((prev) => {
      let updated: IBusinessInfo;
      if (field === "enderecoComercial") {
        updated = {
          ...prev,
          enderecoComercial: {
            ...prev.enderecoComercial,
            ...(value as IBusinessInfo["enderecoComercial"]),
          },
        };
      } else if (field === "legalRepresentative") {
        updated = {
          ...prev,
          legalRepresentative: {
            ...prev.legalRepresentative,
            ...(value as IBusinessInfo["legalRepresentative"]),
          },
        };
      } else if (field === "accountManager") {
        updated = {
          ...prev,
          accountManager: {
            ...prev.accountManager,
            ...(value as IBusinessInfo["accountManager"]),
          },
        };
      } else {
        updated = {
          ...prev,
          [field]: value as string,
        } as IBusinessInfo;
      }
      console.log("📝 Informações do negócio atualizadas:", updated);
      // Salva no localStorage para não perder ao recarregar
      localStorage.setItem("georanking_business_info", JSON.stringify(updated));
      return updated;
    });
  };

  useEffect(() => {
    return () => {
      if (verificationPreviewUrl) {
        URL.revokeObjectURL(verificationPreviewUrl);
      }
    };
  }, [verificationPreviewUrl]);

  useEffect(() => {
    const fetchProfilesByName = async () => {
      if (!filterText.trim() || !user?.token) {
        setSearchedProfiles([]);
        setIsSearchingProfiles(false);
        return;
      }

      setIsSearchingProfiles(true);
      try {
        const profilesData = await GeoRankingService.searchPlacesByName(
          filterText,
          user?.token,
        );
        setSearchedProfiles(profilesData);
      } finally {
        setIsSearchingProfiles(false);
      }
    };

    fetchProfilesByName();
  }, [filterText, user]);

  const handleLogout = () => {
    clearUser();
    navigate("/login");
  };

  // Carrega dados do checkout ao montar o componente
  // NOTA: Comentado temporariamente - backend precisa implementar GET /checkout
  // useEffect(() => {
  //   const fetchCheckoutData = async () => {
  //     if (user?.token) {
  //       const checkoutData = await GeoRankingService.getCheckoutData(user.token);
  //       if (checkoutData) {
  //         setBusinessInfo({
  //           displayName: checkoutData.displayName || "",
  //           razaoSocial: checkoutData.razaoSocial || "",
  //           cpfCnpj: checkoutData.cpfCnpj || "",
  //           enderecoComercial: {
  //             rua: checkoutData.enderecoComercial?.rua || "",
  //             bairro: checkoutData.enderecoComercial?.bairro || "",
  //             cidade: checkoutData.enderecoComercial?.cidade || "",
  //             estado: checkoutData.enderecoComercial?.estado || "",
  //             complemento: checkoutData.enderecoComercial?.complemento || "",
  //           },
  //           telefone: checkoutData.telefone || "",
  //           email: checkoutData.email || "",
  //         });
  //       }
  //     }
  //   };
  //   fetchCheckoutData();
  // }, [user]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        if (searchCategories && searchCategories != "" && user) {
          const profilesData = await GeoRankingService.searchCategories(
            searchCategories,
            user.token,
          );
          const localCategories = profilesData.map((item) => item.category);
          setCategories((prev) => [...new Set([...prev, ...localCategories])]);
        }
      } catch (error) {
        console.error("Erro ao buscar categorias:", error);
      }
    };
    fetchCategories();
  }, [searchCategories, user]);

  // Carrega todos os perfis disponíveis após login e filtra localmente
  useEffect(() => {
    const fetchBriefing = async () => {
      try {
        if (activeStep === 5) {
          setIsStepLoading(true); // Inicia o loading
          if (
            selectedProfile &&
            selectedCategories.length > 0 &&
            user?.token &&
            !selectedProfile.isManual
          ) {
            const payload: IRecommendedBriefingPayload = {
              displayName: selectedProfile.displayName,
              formattedAddress: selectedProfile.formattedAddress,
              types: selectedProfile.types || [],
              categories: selectedCategories,
              keywords: selectedKeywords,
            };
            const briefingText = await GeoRankingService.getRecommendedBriefing(
              payload,
              user.token,
            );
            setDetailsPlan(
              briefingText ||
                buildFallbackBriefing(
                  businessInfo,
                  selectedCategories,
                  selectedKeywords,
                ),
            );
          } else if (selectedProfile && selectedCategories.length > 0) {
            setDetailsPlan(
              buildFallbackBriefing(
                businessInfo,
                selectedCategories,
                selectedKeywords,
              ),
            );
          }
          setIsStepLoading(false); // Finaliza o loading
        }
      } catch (error) {
        console.error("Erro ao gerar briefing:", error);
        setIsStepLoading(false);
      }
    };

    fetchBriefing();
  }, [
    activeStep,
    selectedProfileId,
    selectedCategories,
    selectedKeywords,
    searchedProfiles,
    businessInfo,
    user,
  ]);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        if (user?.token) {
          const plansData = await GeoRankingService.getPlans(user.token);
          setPlans(
            Array.isArray(plansData) && plansData.length > 0
              ? plansData
              : fallbackPlans,
          );
          return;
        }
        setPlans(fallbackPlans);
      } catch (error) {
        console.error("Erro ao carregar planos:", error);
        setPlans(fallbackPlans);
      }
    };
    fetchPlans();
  }, [user]);

  useEffect(() => {
    if (activeStep === 0) {
      // setDisableBtn(!selectedProfileId);
    }
  }, [activeStep, selectedProfileId]);

  const steps = GEORANKING_ONBOARDING_STEPS;
  const profileOptions = searchedProfiles;
  const selectedProfile = profileOptions.find(
    (profile) => profile.profileId === selectedProfileId,
  );

  const handleFinish = async () => {
    // Monta o payload conforme a API /api/v1/checkout
    const payload: INewGeoRankingPayload = {
      displayName: selectedProfile?.displayName ?? "",
      categories: selectedCategories,
      keywords: selectedKeywords,
      briefing: detailsPlan,
      subscriptionPlanId: selectedPlanId ?? 0,
      profileId: selectedProfileId ?? "",
      razaoSocial: businessInfo.razaoSocial,
      cpfCnpj: businessInfo.cpfCnpj,
      enderecoComercial: {
        rua: businessInfo.enderecoComercial.rua,
        bairro: businessInfo.enderecoComercial.bairro,
        cidade: businessInfo.enderecoComercial.cidade,
        estado: businessInfo.enderecoComercial.estado,
        complemento: businessInfo.enderecoComercial.complemento,
      },
      telefone: businessInfo.telefone,
      email: businessInfo.email,
    };

    // Adiciona campos opcionais do businessInfo apenas se preenchidos (conforme /api/v1/checkout)
    if (businessInfo.razaoSocial?.trim()) {
      payload.razaoSocial = businessInfo.razaoSocial.trim();
    }
    if (businessInfo.cpfCnpj?.trim()) {
      payload.cpfCnpj = businessInfo.cpfCnpj.trim();
    }
    if (businessInfo.enderecoComercial) {
      // copia apenas os campos existentes (rua, bairro, cidade, estado, complemento)
      payload.enderecoComercial = {
        rua: businessInfo.enderecoComercial.rua?.trim() ?? "",
        bairro: businessInfo.enderecoComercial.bairro?.trim() ?? "",
        cidade: businessInfo.enderecoComercial.cidade?.trim() ?? "",
        estado: businessInfo.enderecoComercial.estado?.trim() ?? "",
        complemento: businessInfo.enderecoComercial.complemento?.trim() ?? "",
      };
    }
    if (businessInfo.telefone?.trim()) {
      payload.telefone = businessInfo.telefone.trim();
    }
    if (businessInfo.email?.trim()) {
      payload.email = businessInfo.email.trim();
    }
    if (businessInfo.extraDescription?.trim()) {
      payload.extraDescription = businessInfo.extraDescription.trim();
    }

    // Monta array de contatos se preenchidos
    const contacts = [];
    if (
      businessInfo.legalRepresentative &&
      (businessInfo.legalRepresentative.name?.trim() ||
        businessInfo.legalRepresentative.email?.trim() ||
        businessInfo.legalRepresentative.phoneNumber?.trim())
    ) {
      contacts.push({
        name: businessInfo.legalRepresentative.name?.trim() || "",
        email: businessInfo.legalRepresentative.email?.trim() || "",
        phoneNumber: businessInfo.legalRepresentative.phoneNumber?.trim() || "",
        contactType: "LEGAL_REPRESENTATIVE" as const,
      });
    }
    if (
      businessInfo.accountManager &&
      (businessInfo.accountManager.name?.trim() ||
        businessInfo.accountManager.email?.trim() ||
        businessInfo.accountManager.phoneNumber?.trim())
    ) {
      contacts.push({
        name: businessInfo.accountManager.name?.trim() || "",
        email: businessInfo.accountManager.email?.trim() || "",
        phoneNumber: businessInfo.accountManager.phoneNumber?.trim() || "",
        contactType: "ACCOUNT_MANAGER" as const,
      });
    }
    if (contacts.length > 0) {
      payload.contacts = contacts;
    }

    console.log("Enviando payload completo para o backend:", payload);

    setIsSubmitting(true);
    if (!user?.token) {
      const message =
        "Pré-cadastro pronto. Para finalizar sem login, falta conectar o envio público ao Bitrix ou ao checkout.";
      setPaymentError(message);
      setIsSubmitting(false);
      setIsStepLoading(false);
      toast.info(message);
      return;
    }

    if (user) {
      const response = await GeoRankingService.createGeoRankingCampaign(
        payload,
        user?.token,
      );
      if (response?.success) {
        toast.success("Cadastrado com sucesso!");
        setIsStepLoading(false);
        // Limpa as informações salvas após sucesso
        localStorage.removeItem("georanking_business_info");
        setTimeout(() => {
          window.location.href = response.data;
        }, 1500);
      } else {
        setIsStepLoading(false);
        setIsSubmitting(false);
        const errorMessage =
          response.message || "Erro ao gerar o link de pagamento.";
        toast.error(errorMessage);
        setPaymentError(errorMessage);
      }
    }
  };

  const handleNext = async () => {
    try {
      const isLast = activeStep === steps.length - 1;
      if (isLast) {
        handleFinish();
        return;
      }

      // Log das informações do negócio ao sair do step de dados
      if (activeStep === 1) {
        console.log(
          'Saindo do step "Informações" com os dados:',
          businessInfo,
        );
      }

      // Lógica para buscar categorias ao sair da etapa de perfil
      if (activeStep === 2) {
        setIsStepLoading(true);

        if (selectedProfile && user?.token && !selectedProfile.isManual) {
          const payload: IRecommendedCategoriesPayload = {
            displayName: selectedProfile.displayName ?? "",
            formattedAddress: selectedProfile.formattedAddress ?? "",
            types: selectedProfile.types || [],
          };
          const recommended = await GeoRankingService.getRecommendedCategories(
            payload,
            user.token,
          );
          const uniqueRecommended = [...new Set(recommended)];
          setCategories(
            uniqueRecommended.length > 0
              ? uniqueRecommended
              : buildFallbackCategories(businessInfo),
          );
        } else {
          setCategories(buildFallbackCategories(businessInfo));
        }
        setIsStepLoading(false);
      }

      // Lógica para buscar palavras-chave ao sair da etapa de categoria
      if (activeStep === 3) {
        setIsStepLoading(true);

        if (
          selectedProfile &&
          user?.token &&
          !selectedProfile.isManual &&
          selectedCategories.length > 0
        ) {
          const payload: IRecommendedKeywordsPayload = {
            displayName: selectedProfile.displayName ?? "",
            formattedAddress: selectedProfile.formattedAddress ?? "",
            types: selectedProfile.types || [],
            categories: selectedCategories,
          };
          const keywords = await GeoRankingService.getRecommendedKeywords(
            payload,
            user.token,
          );
          const uniqueKeywords = [...new Set(keywords)];
          setSuggestions(
            uniqueKeywords.length > 0
              ? uniqueKeywords
              : buildFallbackKeywords(businessInfo, selectedCategories),
          );
        } else if (selectedCategories.length > 0) {
          setSuggestions(buildFallbackKeywords(businessInfo, selectedCategories));
        }
        setIsStepLoading(false);
      }

      const nextStep = activeStep + 1;
      // Se a próxima etapa for a de descrição, ativa o loading antes de mudar
      if (nextStep === 5) {
        setIsStepLoading(true);
      }
      if (nextStep === 7) {
        setIsStepLoading(true);
        setPaymentError(null); // Limpa erros anteriores
        handleFinish();
      }
      setActiveStep(nextStep);
    } catch (error) {
      console.error("Erro ao avançar etapa:", error);
      setIsStepLoading(false);
      toast.error("Ocorreu um erro ao avançar. Tente novamente.");
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChipClick = (category: string) => {
    setSelectedCategories((prev) => {
      const isSelected = prev.includes(category);
      if (isSelected) {
        return prev.filter((c) => c !== category);
      }
      if (prev.length < 9) {
        return [...prev, category];
      }
      toast.warn("Você pode selecionar no máximo 9 categorias.");
      return prev;
    });
  };

  const handleKeywordDelete = (keywordToDelete: string) => {
    setSelectedKeywords((keywords) =>
      keywords.filter((keyword) => keyword !== keywordToDelete),
    );
  };

  const handleAddKeyword = (keywordToAdd: string) => {
    if (
      keywordToAdd &&
      selectedKeywords.length < 20 &&
      !selectedKeywords.includes(keywordToAdd)
    ) {
      setSelectedKeywords([...selectedKeywords, keywordToAdd]);
      setKeywordInput("");
    }
  };

  // Filtra as sugestões para mostrar apenas as que não foram selecionadas
  const availableSuggestions = suggestions.filter(
    (suggestion) => !selectedKeywords.includes(suggestion),
  );

  const isBusinessInfoStepValid = isBusinessInfoComplete(businessInfo);
  const isProfileStepValid = !!selectedProfileId;
  const isCategoryStepValid = selectedCategories.length > 0;
  const isKeywordsStepValid = selectedKeywords.length > 0;
  const isSummaryStepValid = !!detailsPlan; // Permite avançar apenas se o resumo foi carregado
  const isPlanStepValid = !!selectedPlanId;

  const canProceed = (() => {
    switch (activeStep) {
      case 0:
        return isValidationStepComplete({
          acceptedTerms,
          hasOAuthToken: !!user?.token,
        });
      case 1:
        return isBusinessInfoStepValid;
      case 2:
        return isProfileStepValid;
      case 3:
        return isCategoryStepValid;
      case 4:
        return isKeywordsStepValid;
      case 5:
        return isSummaryStepValid;
      case 6:
        return isPlanStepValid;
      case 7:
        return false; // Desabilita o botão "Finalizar" do rodapé na etapa de pagamento
      default:
        return false;
    }
  })();


  // const mockedPlans = [
  //   {
  //     id: 1,
  //     title: "Bronze",
  //     subtitle: "Entrada inicial para pequenos negócios.",
  //     price: 210,
  //     badgeText: undefined,
  //     ctaLabel: "Escolher Bronze",
  //     variant: "bronze" as const,
  //     features: [
  //       {
  //         label: "Painel do Cliente",
  //         description: "Acesso básico aos dados.",
  //         type: "painel" as const,
  //       },
  //       {
  //         label: "Raio: até 2 km",
  //         description: "Foco na vizinhança.",
  //         type: "raio" as const,
  //       },
  //       {
  //         label: "2 Palavras‑chave",
  //         description: "Termos de busca principais.",
  //         type: "keywords" as const,
  //       },
  //       {
  //         label: "2 Impulsionamentos",
  //         description: "Ações quinzenais.",
  //         type: "impulsionamentos" as const,
  //       },
  //       {
  //         label: "IA Responde",
  //         description: "Avaliações até 3 estrelas.",
  //         type: "ia" as const,
  //       },
  //       {
  //         label: "Suporte 0800",
  //         description: "Central de atendimento.",
  //         type: "suporte" as const,
  //       },
  //       {
  //         label: "Consultor Dedicado",
  //         description: "Gestão de carteira VIP.",
  //         type: "consultor" as const,
  //         disabled: true,
  //       },
  //       {
  //         label: "Site Landing Page",
  //         description: "Landing page profissional.",
  //         type: "landing" as const,
  //         disabled: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "Prata",
  //     subtitle: "Expansão para bairros vizinhos.",
  //     price: 294,
  //     badgeText: undefined,
  //     ctaLabel: "Escolher Prata",
  //     variant: "prata" as const,
  //     features: [
  //       {
  //         label: "Painel do Cliente",
  //         description: "Acesso completo.",
  //         type: "painel" as const,
  //       },
  //       {
  //         label: "Raio: até 5 km",
  //         description: "Alcance estendido.",
  //         type: "raio" as const,
  //       },
  //       {
  //         label: "4 Palavras‑chave",
  //         description: "Mais chances de busca.",
  //         type: "keywords" as const,
  //       },
  //       {
  //         label: "4 Impulsionamentos",
  //         description: "Ações semanais (4x/mês).",
  //         type: "impulsionamentos" as const,
  //       },
  //       {
  //         label: "IA Responde",
  //         description: "Avaliações até 3 estrelas.",
  //         type: "ia" as const,
  //       },
  //       {
  //         label: "Suporte 0800",
  //         description: "Central de atendimento.",
  //         type: "suporte" as const,
  //       },
  //       {
  //         label: "Consultor Dedicado",
  //         description: "Gestão de carteira VIP.",
  //         type: "consultor" as const,
  //         disabled: true,
  //       },
  //       {
  //         label: "Site Landing Page",
  //         description: "Landing page profissional.",
  //         type: "landing" as const,
  //         disabled: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     title: "Ouro",
  //     subtitle: "Alto desempenho e inteligência.",
  //     price: 374,
  //     badgeText: undefined,
  //     ctaLabel: "Escolher Ouro",
  //     variant: "ouro" as const,
  //     features: [
  //       {
  //         label: "Painel Inteligente",
  //         description: "Relatórios com insights.",
  //         type: "painel" as const,
  //       },
  //       {
  //         label: "Raio: até 10 km",
  //         description: "Cobertura estratégica.",
  //         type: "raio" as const,
  //       },
  //       {
  //         label: "6 Palavras‑chave",
  //         description: "Captura múltipla.",
  //         type: "keywords" as const,
  //       },
  //       {
  //         label: "12 Impulsionamentos",
  //         description: "Frequência 3x semana.",
  //         type: "impulsionamentos" as const,
  //       },
  //       {
  //         label: "IA Responde",
  //         description: "Avaliações até 3 estrelas.",
  //         type: "ia" as const,
  //       },
  //       {
  //         label: "Suporte 0800",
  //         description: "Central de atendimento.",
  //         type: "suporte" as const,
  //       },
  //       {
  //         label: "Consultor Dedicado",
  //         description: "Gestão de carteira VIP.",
  //         type: "consultor" as const,
  //         highlighted: true,
  //       },
  //       {
  //         label: "Site Landing Page",
  //         description: "Landing page profissional.",
  //         type: "landing" as const,
  //         disabled: true,
  //       },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     title: "Diamante",
  //     subtitle: "Solução completa: Tráfego + Site.",
  //     price: 499,
  //     badgeText: "Melhor custo‑benefício",
  //     ctaLabel: "Quero o Diamante",
  //     variant: "diamante" as const,
  //     features: [
  //       {
  //         label: "Painel VIP Completo",
  //         description: "Prioridade de dados.",
  //         type: "vip" as const,
  //       },
  //       {
  //         label: "Raio: até 15 km",
  //         description: "Alcance máximo permitido.",
  //         type: "raio" as const,
  //       },
  //       {
  //         label: "8 Palavras‑chave",
  //         description: "Domínio total das buscas.",
  //         type: "keywords" as const,
  //       },
  //       {
  //         label: "20 Impulsionamentos",
  //         description: "Diário (Segunda a Sexta).",
  //         type: "impulsionamentos" as const,
  //         highlighted: true,
  //       },
  //       {
  //         label: "IA Responde",
  //         description: "Avaliações até 3 estrelas.",
  //         type: "ia" as const,
  //       },
  //       {
  //         label: "Suporte 0800",
  //         description: "Central de atendimento.",
  //         type: "suporte" as const,
  //       },
  //       {
  //         label: "Consultor Dedicado",
  //         description: "Gestão de carteira VIP.",
  //         type: "consultor" as const,
  //       },
  //       {
  //         label: "Site Landing Page",
  //         description: "Landing page profissional.",
  //         type: "landing" as const,
  //         highlighted: true,
  //       },
  //     ],
  //   },
  // ];

  const parseCard = (plans: IPlan[]) => {
    // TODO create a interface and prune the usage of "any"
    const parsedPlans: any[] = [];
    plans.forEach((plan) => {
      switch (plan.externalId) {
        case "price_1T2d8sB9zvD0uiNfzEHmss9E":
          parsedPlans.push({
            id: plan.id,
            title: plan.name,
            subtitle: "Entrada inicial para pequenos negócios.",
            price: plan.monthlyCost,
            badgeText: undefined,
            ctaLabel: `Escolher bronze`,
            variant: "bronze" as const,
            features: [
              {
                label: "Painel do Cliente",
                description: "Acesso básico aos dados.",
                type: "painel" as const,
              },
              {
                label: "Raio: até 2 km",
                description: "Foco na vizinhança.",
                type: "raio" as const,
              },
              {
                label: `2 Palavras‑chave`,
                description: "Termos de busca principais.",
                type: "keywords" as const,
              },
              {
                label: "2 Impulsionamentos",
                description: "Ações quinzenais.",
                type: "impulsionamentos" as const,
              },
              {
                label: "IA Responde",
                description: "Avaliações até 3 estrelas.",
                type: "ia" as const,
              },
              {
                label: "Suporte 0800",
                description: "Central de atendimento.",
                type: "suporte" as const,
              },
              {
                label: "Consultor Dedicado",
                description: "Gestão de carteira VIP.",
                type: "consultor" as const,
                disabled: true,
              },
              {
                label: "Site Landing Page",
                description: "Landing page profissional.",
                type: "landing" as const,
                disabled: true,
              },
            ],
          });
          break;
        case "price_1T2dClB9zvD0uiNfCX38NBKD":
          parsedPlans.push({
            id: plan.id,
            title: plan.name,
            subtitle: "Expansão para bairros vizinhos.",
            price: plan.monthlyCost,
            badgeText: undefined,
            ctaLabel: `Escolher prata`,
            variant: "prata" as const,
            features: [
              {
                label: "Painel do Cliente",
                description: "Acesso completo.",
                type: "painel" as const,
              },
              {
                label: "Raio: até 5 km",
                description: "Alcance estendido.",
                type: "raio" as const,
              },
              {
                label: `4 Palavras‑chave`,
                description: "Mais chances de busca.",
                type: "keywords" as const,
              },
              {
                label: "4 Impulsionamentos",
                description: "Ações semanais (4x/mês).",
                type: "impulsionamentos" as const,
              },
              {
                label: "IA Responde",
                description: "Avaliações até 3 estrelas.",
                type: "ia" as const,
              },
              {
                label: "Suporte 0800",
                description: "Central de atendimento.",
                type: "suporte" as const,
              },
              {
                label: "Consultor Dedicado",
                description: "Gestão de carteira VIP.",
                type: "consultor" as const,
                disabled: true,
              },
              {
                label: "Site Landing Page",
                description: "Landing page profissional.",
                type: "landing" as const,
                disabled: true,
              },
            ],
          });
          break;
        case "price_1T2dFDB9zvD0uiNf5NKK5ebr":
          parsedPlans.push({
            id: plan.id,
            title: plan.name,
            subtitle: "Alto desempenho e inteligência.",
            price: plan.monthlyCost,
            badgeText: "Melhor custo‑benefício",
            ctaLabel: `Escolher ouro`,
            variant: "ouro" as const,
            features: [
              {
                label: "Painel Inteligente",
                description: "Relatórios com insights.",
                type: "painel" as const,
              },
              {
                label: "Raio: até 10 km",
                description: "Cobertura estratégica.",
                type: "raio" as const,
              },
              {
                label: `6 Palavras‑chave`,
                description: "Captura múltipla.",
                type: "keywords" as const,
              },
              {
                label: "12 Impulsionamentos",
                description: "Frequência 3x semana.",
                type: "impulsionamentos" as const,
              },
              {
                label: "IA Responde",
                description: "Avaliações até 3 estrelas.",
                type: "ia" as const,
              },
              {
                label: "Suporte 0800",
                description: "Central de atendimento.",
                type: "suporte" as const,
              },
              {
                label: "Consultor Dedicado",
                description: "Gestão de carteira VIP.",
                type: "consultor" as const,
                highlighted: true,
              },
              {
                label: "Site Landing Page",
                description: "Landing page profissional.",
                type: "landing" as const,
                disabled: true,
              },
            ],
          });
          break;
        case "price_1T2dGUB9zvD0uiNf3GT1K1tO":
          parsedPlans.push({
            id: plan.id,
            title: plan.name,
            subtitle: "Solução completa: Tráfego + Site.",
            price: plan.monthlyCost,
            badgeText: undefined,
            ctaLabel: `Quero o diamante`,
            variant: "diamante" as const,
            features: [
              {
                label: "Painel VIP Completo",
                description: "Prioridade de dados.",
                type: "vip" as const,
              },
              {
                label: "Raio: até 15 km",
                description: "Alcance máximo permitido.",
                type: "raio" as const,
              },
              {
                label: `8 Palavras‑chave`,
                description: "Domínio total das buscas.",
                type: "keywords" as const,
              },
              {
                label: "20 Impulsionamentos",
                description: "Diário (Segunda a Sexta).",
                type: "impulsionamentos" as const,
                highlighted: true,
              },
              {
                label: "IA Responde",
                description: "Avaliações até 3 estrelas.",
                type: "ia" as const,
              },
              {
                label: "Suporte 0800",
                description: "Central de atendimento.",
                type: "suporte" as const,
              },
              {
                label: "Consultor Dedicado",
                description: "Gestão de carteira VIP.",
                type: "consultor" as const,
              },
              {
                label: "Site Landing Page",
                description: "Landing page profissional.",
                type: "landing" as const,
                highlighted: true,
              },
            ],
          });
          break;
      }
    });

    const order = ["bronze", "prata", "ouro", "diamante"];
    parsedPlans.sort(
      (a, b) => order.indexOf(a.variant) - order.indexOf(b.variant)
    );

    return parsedPlans;
  };

  if (shouldShowOAuthLoginFirst(!!user?.token)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Page.Root>
      <TopContainer>
        {!isMobile() && user && (
          <LogoutButton onClick={handleLogout}>
            <LogoutIcon sx={{ fontSize: 18 }} />
            Sair
          </LogoutButton>
        )}
        <div className="brand-row">
          <img src={gpv} alt="" className="left-image" />
          <span className="subtitle">
            Contratação guiada de SEO local, simples e segura
          </span>
        </div>
        {!isMobile() && (
          <div className="stepper-shell">
            <CustomStepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </CustomStepper>
          </div>
        )}
      </TopContainer>
      <BottomContainer data-step={activeStep}>
        {isStepLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Page.Loader />
          </div>
        ) : (
          <>
            <div className="container-data">
              <span className="title">{steps[activeStep]}</span>
              <span className="subtitle">
                {getStepSupportText(activeStep)}
                {activeStep === 3 && selectedCategories.length > 0 && (
                  <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                    ({selectedCategories.length}/9)
                  </span>
                )}
                {activeStep === 7 &&
                  `Escolhido: ${
                    plans.find((p) => p.id === selectedPlanId)?.name
                  }`}
              </span>
            </div>
            {activeStep !== 0 && (
              <OnboardingHelp>
                <span className="eyebrow">Passo {activeStep + 1} de {steps.length}</span>
                <strong>
                  {activeStep === 1 && "Dados simples para contrato e contato"}
                  {activeStep === 2 && "Encontre seu perfil no Google"}
                  {activeStep === 3 && "Escolha como o Google deve entender seu negócio"}
                  {activeStep === 4 && "Defina as buscas que valem dinheiro"}
                  {activeStep === 5 && "Texto público claro e confiável"}
                  {activeStep === 6 && "Plano conforme raio e volume de ações"}
                  {activeStep === 7 && "Contratação segura"}
                </strong>
                <p>{getStepSupportText(activeStep)}</p>
              </OnboardingHelp>
            )}
            {activeStep === 0 && (
              <TermsContainer>
                <div className="validation-header">
                  <span className="validation-eyebrow">Passo 1 de 8</span>
                  <div className="validation-title-row">
                    <div>
                      <h2>Validação comercial</h2>
                      <p>
                        Conecte sua conta Google para buscar o perfil real,
                        confirme os documentos e envie uma evidência simples se
                        quiser. Nada é publicado no Google sem revisão.
                      </p>
                    </div>
                    {user?.token ? (
                      <div className="google-signal connected">
                        <VerifiedUserOutlinedIcon />
                        <span>Google conectado para buscar perfis reais</span>
                      </div>
                    ) : (
                      <div className="oauth-card">
                        <GoogleIcon />
                        <span>
                          <strong>Entrar com Google</strong>
                          Autorize a conta antes de escolher o perfil. O Google
                          exige token para mostrar resultados reais.
                        </span>
                        <button
                          type="button"
                          onClick={handleGoogleOAuth}
                          disabled={isStartingOAuth}
                        >
                          {isStartingOAuth ? "Conectando..." : "Conectar Google"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="trust-strip" aria-label="Garantias do processo">
                  {VALIDATION_TRUST_SIGNALS.map((signal) => (
                    <span key={signal}>
                      <TaskAltOutlinedIcon fontSize="small" />
                      {signal}
                    </span>
                  ))}
                </div>
                <div className="validation-layout">
                  <div className="validation-main">
                    <span className="section-label">
                      <PhotoCameraOutlinedIcon fontSize="small" />
                      Evidência do negócio opcional
                    </span>
                    <div
                      className="validation-actions"
                      role="group"
                      aria-label="Tipo de foto"
                    >
                      <button
                        type="button"
                        className={verificationKind === "storefront" ? "active" : ""}
                        onClick={() => setVerificationKind("storefront")}
                      >
                        <PhotoCameraOutlinedIcon fontSize="small" />
                        Foto da fachada
                      </button>
                      <button
                        type="button"
                        className={verificationKind === "selfie" ? "active" : ""}
                        onClick={() => setVerificationKind("selfie")}
                      >
                        <PersonOutlineOutlinedIcon fontSize="small" />
                        Selfie do responsável
                      </button>
                    </div>

                    <label className="upload-area">
                      <input
                        type="file"
                        accept="image/*"
                        capture={
                          verificationKind === "storefront" ? "environment" : "user"
                        }
                        onChange={(event) =>
                          handleVerificationFileChange(event.target.files?.[0])
                        }
                      />
                      {verificationPreviewUrl ? (
                        <span className="preview-shell">
                          <img
                            src={verificationPreviewUrl}
                            alt="Prévia da validação"
                          />
                          <small>Arquivo selecionado para conferência</small>
                        </span>
                      ) : (
                        <span className="upload-placeholder">
                          <CloudUploadOutlinedIcon />
                          Enviar foto
                          <small>JPG, PNG ou foto tirada pelo celular</small>
                        </span>
                      )}
                    </label>
                    {verificationFile && (
                      <span className="file-name">{verificationFile.name}</span>
                    )}
                    <div className="upload-footnote">
                      <GppGoodOutlinedIcon fontSize="small" />
                      A imagem é usada somente para validar a contratação e
                      orientar a equipe comercial.
                    </div>
                  </div>

                  <div className="validation-copy">
                    <span className="panel-eyebrow">Conferência GeoRanking</span>
                    <strong>Como funciona essa validação</strong>
                    <p>
                      O login Google libera a busca de perfis reais e reduz erro
                      de cadastro antes da contratação.
                    </p>
                    <ol className="checkpoint-list">
                      {VALIDATION_CHECKPOINTS.map((checkpoint) => (
                        <li key={checkpoint}>
                          <TaskAltOutlinedIcon fontSize="small" />
                          <span>{checkpoint}</span>
                        </li>
                      ))}
                    </ol>
                    <div className="profile-signal">
                      <ManageSearchOutlinedIcon />
                      <span>
                        <strong>Perfil Google verificado no fluxo</strong>
                        <small>
                          Com OAuth buscamos perfis conectados. Sem OAuth, a
                          equipe confere o perfil público informado pelo cliente.
                        </small>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="terms-box">
                  <span className="terms-copy">
                    <strong>Documentos oficiais</strong>
                    Ao continuar, você confirma que leu e aceita os documentos do
                    GeoRanking para esta contratação.
                  </span>
                  <div className="terms-links">
                    {LEGAL_DOCUMENT_LINKS.map((link) => (
                      <a
                        key={link.href}
                        href={link.href}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {link.label}
                        <OpenInNewOutlinedIcon fontSize="inherit" />
                      </a>
                    ))}
                  </div>
                </div>
                <FormControlLabel
                  sx={{ marginTop: "18px", alignSelf: "flex-start" }}
                  control={
                    <Checkbox
                      checked={acceptedTerms}
                      onChange={(event) =>
                        handleAcceptedTermsChange(event.target.checked)
                      }
                    />
                  }
                  label="Li, entendi e quero continuar a contratação"
                />
                <div className="validation-footer-action">
                  <StyledButton
                    type="button"
                    onClick={handleNext}
                    disabled={!canProceed || isSubmitting}
                  >
                    {user?.token
                      ? "Continuar para Dados"
                      : "Conecte o Google para continuar"}
                  </StyledButton>
                </div>
              </TermsContainer>
            )}
            {activeStep === 1 && (
              <BusinessInfoForm
                formData={businessInfo}
                onChange={handleBusinessInfoChange}
              />
            )}
            {activeStep === 2 && (
              <FirstStep>
                {!user?.token && (
                  <div className="profile-auth-notice">
                    <ManageSearchOutlinedIcon />
                    <span>
                      <strong>Conecte o Google para buscar perfis reais</strong>
                      O endpoint de perfis exige token OAuth. Volte para a
                      primeira etapa e conecte a conta antes de continuar.
                    </span>
                    <button type="button" onClick={handleGoogleOAuth}>
                      Conectar Google
                    </button>
                  </div>
                )}
                <SearchContainer>
                  <Page.Search
                    key={"search-companies"}
                    placeholder={"Digite o nome que aparece no Google"}
                    changeTextSearch={(texto) =>
                      debounce(() => {
                        setFilterText(texto);
                        if (selectedProfileId?.startsWith("manual-")) {
                          setSelectedProfileId(null);
                        }
                      })
                    }
                  />
                </SearchContainer>
                <ProfilesContainer>
                  {isSearchingProfiles ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "180px",
                      }}
                    >
                      <Page.Loader />
                    </div>
                  ) : profileOptions.length > 0 ? (
                    profileOptions.map((p) => (
                      <SelectableTile
                        key={p.profileId}
                        id={p.profileId}
                        label={p.displayName ?? "Sem nome"}
                        address={p.formattedAddress ?? ""}
                        icon={<StoreOutlinedIcon />}
                        selected={selectedProfileId === p.profileId}
                        onSelect={(id) => setSelectedProfileId(id)}
                      />
                    ))
                  ) : (
                    <div className="profile-empty-state">
                      <ManageSearchOutlinedIcon />
                      <strong>Nenhum perfil encontrado para essa busca.</strong>
                      <span>
                        Revise o nome digitado ou tente pesquisar pelo nome
                        público completo exibido no Google.
                      </span>
                    </div>
                  )}
                </ProfilesContainer>
              </FirstStep>
            )}
            {activeStep === 3 && (
              <>
                <TagContainer>
                  <LocalOfferIcon
                    sx={{
                      color: "#ffbf00",
                      fontSize: 35,
                      marginInline: "5px",
                      marginTop: "6px",
                    }}
                  />
                </TagContainer>
                <SearchContainer>
                  <Page.Search
                    key={"search-categories"}
                    placeholder={"Pesquisar categoria..."}
                    changeTextSearch={(text) => {
                      debounce(() => {
                        setSearchCategories(text);
                        setCategorySearch(text);
                      });
                    }}
                  />
                </SearchContainer>
                <ChipGrid>
                  {categories &&
                    categories
                      .filter((category) =>
                        category
                          .toLowerCase()
                          .includes(categorySearch.toLowerCase()),
                      )
                      .map((category) => (
                        <Tooltip
                          key={category}
                          title={category}
                          arrow
                          placement="top"
                        >
                          <CategoryChip
                            label={category}
                            onClick={() => handleChipClick(category)}
                            selected={selectedCategories.includes(category)}
                            $selected={selectedCategories.includes(category)}
                            selectionType={
                              selectedCategories[0] === category
                                ? "primary"
                                : "secondary"
                            }
                          />
                        </Tooltip>
                      ))}
                </ChipGrid>
              </>
            )}
            {activeStep === 4 && (
              <KeywordsContainer>
                <SelectedChipsContainer>
                  {selectedKeywords.map((keyword) => (
                    <Chip
                      key={keyword}
                      label={keyword}
                      onDelete={() => handleKeywordDelete(keyword)}
                      color="primary"
                      style={{ backgroundColor: "#1264C7" }}
                    />
                  ))}
                </SelectedChipsContainer>
                <p style={{ alignSelf: "flex-start", color: "#6b7280" }}>
                  {selectedKeywords.length} / 20
                </p>
                <InputContainer>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Digite e pressione Enter"
                    value={keywordInput}
                    onChange={(e) => setKeywordInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleAddKeyword(keywordInput);
                      }
                    }}
                  />
                  <IconButton onClick={() => handleAddKeyword(keywordInput)}>
                    <AddIcon />
                  </IconButton>
                </InputContainer>
                <SuggestionsContainer>
                  <span
                    style={{
                      alignSelf: "flex-start",
                      fontWeight: "500",
                      color: "black",
                    }}
                  >
                    Sugestões:
                  </span>
                  <div>
                    {availableSuggestions.map((suggestion) => (
                      <Chip
                        key={suggestion}
                        label={suggestion}
                        onClick={() => handleAddKeyword(suggestion)}
                        style={{ margin: "4px" }}
                        disabled={selectedKeywords.length >= 20}
                      />
                    ))}
                  </div>
                </SuggestionsContainer>
              </KeywordsContainer>
            )}
            {activeStep === 5 && (
              <>
                <DetailsArea
                  value={detailsPlan}
                  onChange={(e) => setDetailsPlan(e.target.value)}
                />
              </>
            )}
            {activeStep === 6 && (
              <PlansContainer>
                {parseCard(plans).map((plan) => (
                  <PlanCardNew
                    key={plan.id}
                    title={plan.title}
                    subtitle={plan.subtitle}
                    price={plan.price}
                    period="/mês"
                    badgeText={plan.badgeText}
                    ctaLabel={plan.ctaLabel}
                    features={plan.features}
                    variant={plan.variant}
                    isSelected={selectedPlanId === plan.id}
                    onSelect={() => setSelectedPlanId(plan.id)}
                  />
                ))}
              </PlansContainer>
              // <PlansContainer>
              //   {plans.map((plan) => (
              //     <PlanCard
              //       key={plan.id}
              //       title={plan.name}
              //       price={plan.monthlyCost.toString()}
              //       installments={`12x • Total R$ ${(
              //         plan.monthlyCost * 12
              //       ).toLocaleString("pt-BR")}`}
              //       features={[
              //         { label: "Palavras-chave", value: plan.maxKeywords },
              //         {
              //           label: "Palavras-chave otimizadas",
              //           value: plan.maxKeywords,
              //         },
              //         {
              //           label: "Cartão de visita digital",
              //           value: plan.visitCard,
              //         },
              //         { label: "QR Code para avaliações", value: plan.qrCode },
              //       ]}
              //       isRecommended={plan.name.toUpperCase() === "TURBO"}
              //       isSelected={selectedPlanId === plan.id}
              //       onSelect={() => setSelectedPlanId(plan.id)}
              //     />
              //   ))}
              // </PlansContainer>
            )}
            {activeStep === 7 && (
              <>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginBottom: 12,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "roboto",
                      fontWeight: 700,
                      color: "black",
                    }}
                  >
                    {paymentError
                      ? paymentError
                      : "Gerando link de pagamento..."}
                  </span>
                  {paymentError && (
                    <StyledButton
                      onClick={() => {
                        setActiveStep(6);
                        setIsSubmitting(false);
                      }}
                      style={{ width: "fit-content" }}
                    >
                      Tentar Novamente
                    </StyledButton>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </BottomContainer>

      {/* {!isMobile() && (
        <Footer>
          {activeStep !== steps.length - 1 && (
            <StyledButton onClick={handleBack} disabled={activeStep === 0}>
              Voltar
            </StyledButton>
          )}
          {activeStep !== steps.length - 1 && (
            <StyledButton
              onClick={handleNext}
              disabled={!canProceed || isSubmitting}
            >
              {isSubmitting ? "Finalizando..." : "Próximo"}
            </StyledButton>
          )}
        </Footer>
      )} */}

      {activeStep !== 0 && (
        <div
          style={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            padding: "8px 12px",
            background: "#ffffff",
            boxShadow: "0 -6px 20px rgba(18, 38, 63, 0.06)",
            zIndex: 1200,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <MobileStepper
            variant="text"
            steps={steps.length}
            position="static"
            activeStep={activeStep}
            nextButton={
              activeStep !== steps.length - 1 && (
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={!canProceed || isSubmitting}
                  sx={{
                    backgroundColor: !canProceed ? "#E5E7EB" : "#1264C7",
                    color: !canProceed ? "#9CA3AF" : "#fff",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    "&:hover": {
                      backgroundColor: !canProceed ? "#E5E7EB" : "#3367D6",
                    },
                  }}
                >
                  {isSubmitting ? "Finalizando..." : "Próximo"}
                </Button>
              )
            }
            backButton={
              activeStep !== steps.length - 1 && (
                <Button
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                  sx={{
                    backgroundColor:
                      activeStep === 0 ? "#F3F4F6" : "transparent",
                    color: "#111827",
                    textTransform: "none",
                    borderRadius: "8px",
                    padding: "6px 12px",
                  }}
                >
                  Voltar
                </Button>
              )
            }
            sx={{ columnGap: "5vw" }}
          />
        </div>
      )}
    </Page.Root>
  );
};
